module.exports = __webpack_public_path__ + "img/14.e8e5dec1.jpg";